import { ref } from 'vue'
import { defineStore, storeToRefs } from 'pinia'
import { useTradeTabsStore } from './tabs'

const useTradeStore = defineStore('trade', () => {
  const tabsStore = useTradeTabsStore()

  const { tabs, selectedTab } = storeToRefs(tabsStore)

  const skipCloseOrderConfirm = ref(false)

  const {
    setTabs,
    selectTab,
    persistTabsForLogin,
    restoreTabsForLogin,
    reset: resetTabs,
  } = tabsStore

  const reset = () => {
    skipCloseOrderConfirm.value = false
    resetTabs()
  }

  return {
    // state
    tabs,
    selectedTab,
    skipCloseOrderConfirm,

    // methods
    setTabs,
    selectTab,

    // 持久化
    persistTabsForLogin,
    restoreTabsForLogin,

    // 其它
    reset,
  }
})

export default useTradeStore
export { useTradeStore }
